import { Select } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  ArrowTriangleDown,
  CheckMarkIcon,
  CreateIcon,
} from "../../../constants/svg";
import { setResourceAddEditForm } from "../../../store/slices/resourcesSlice";
import GenericModal from "../../Modals/GenericModal";
import ResourcesModalSteps from "./ResourceModal/ResourcesModalSteps";
import { roles as salonRoles } from "../../../utils/constants";
import { GetAuthUserLocalStorage } from "../../../services/localStorage/localStorage";
import {
  setCurrentSalonID,
  setSelectPreUploadedFile,
} from "../../../store/slices/globalSlice";

const ResourceHeader = (props) => {
  const { resources, resourceFolders, isResourcesLoading } = useSelector(
    (state) => state?.resources,
  );
  const { categories, allSalons, currentSalonId } = useSelector(
    (state) => state.global,
  );
  const { resourceAddEditForm } = useSelector((state) => state.resources);
  const dispatch = useDispatch();

  const selectedFolder =
    resourceFolders?.data?.find(
      (folder) => folder.id == props.selectedCategory,
    ) ||
    categories?.find((category) => category.value == props.selectedCategory);

  const selectedFolderName =
    selectedFolder?.name || selectedFolder?.label || "";

  const isFolderDrillIn =
    props.activeTab == "resources" && !!props.selectedCategory;

  const foldersResourceTotal = (resourceFolders?.data || []).reduce(
    (sum, folder) => sum + (folder.resources_count || 0),
    0,
  );

  // While a filtered fetch is in flight, prefer the folder card count so the
  // badge doesn't flash the previous unfiltered total (e.g. 3 → 1).
  const resourcesCount = isFolderDrillIn
    ? isResourcesLoading && selectedFolder?.resources_count != null
      ? selectedFolder.resources_count
      : resources?.meta?.total || 0
    : (resources?.meta?.total ?? foldersResourceTotal);

  const categoryOptions = [
    { value: "All Categories", label: "All Categories" },
    ...(categories || []),
  ];

  return (
    <>
      <div className="globalHeader resourceHeader">
        <div className="globalHeader--left">
          <h2 className="sec-heading">Resources</h2>
          <div className="customTablist">
            <div className="customTabItem">
              <div
                className={props.activeTab == "folders" ? "tab active" : "tab"}
                onClick={() => props.setActiveTab("folders")}
              >
                Categories ({resourceFolders?.data?.length || 0})
              </div>
            </div>
            <div className="customTabItem">
              <div
                className={
                  props.activeTab == "resources" ? "tab active" : "tab"
                }
                onClick={() => props.setActiveTab("resources")}
              >
                {isFolderDrillIn ? (
                  <>
                    <span
                      className="resource-folder-crumb"
                      onClick={(e) => {
                        e.stopPropagation();
                        props.setActiveTab("folders");
                      }}
                    >
                      {selectedFolderName}
                    </span>
                    <span className="resource-folder-crumb-sep">»</span>
                    Resources ({resourcesCount})
                  </>
                ) : (
                  <>Resources ({resourcesCount})</>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="globalHeader--right">
          {GetAuthUserLocalStorage().roles[0].id == salonRoles.super_admin && (
            <Select
              defaultValue="All Organizations"
              value={currentSalonId || undefined}
              suffixIcon={<ArrowTriangleDown />}
              menuItemSelectedIcon={<CheckMarkIcon />}
              onChange={(e) => {
                dispatch(setCurrentSalonID(e));
              }}
              popupClassName="main-select pageDropdown header-dropdown me-3"
              className="custom-select-box border"
              options={allSalons.map((elem) => {
                return { value: elem.id, label: elem.name };
              })}
              getPopupContainer={() => document.getElementById("area")}
            />
          )}

          {/* Category filter is hidden for now — browsing happens via the
              Categories tab and management lives in Settings.
          <Select
            value={
              props.selectedCategory ? props.selectedCategory : "All Categories"
            }
            suffixIcon={<ArrowTriangleDown />}
            menuItemSelectedIcon={<CheckMarkIcon />}
            popupClassName="main-select pageDropdown header-dropdown me-3"
            className="custom-select-box border"
            options={categoryOptions}
            onChange={(e) => {
              const nextCategory = e == "All Categories" ? "" : e;
              props.setSelectedCategory(nextCategory);
            }}
            getPopupContainer={() => document.getElementById("area")}
          />
          */}
          <NavLink
            to="/settings/categories"
            className="resource-manage-categories"
          >
            Manage Categories
          </NavLink>
          <button
            className="btn-gradient"
            onClick={() => {
              dispatch(
                setResourceAddEditForm({
                  show: true,
                  formType: "create",
                }),
              );
            }}
          >
            <span>
              <CreateIcon />
            </span>
            Add Resource
          </button>
        </div>
        {resourceAddEditForm.show && (
          <GenericModal
            show={resourceAddEditForm.show}
            onHide={() => {
              dispatch(
                setResourceAddEditForm({
                  show: false,
                  formType: null,
                }),
              );
              dispatch(setSelectPreUploadedFile([]));
            }}
            setModalShow={(e) => {
              dispatch(
                setResourceAddEditForm({
                  show: e,
                  formType: null,
                }),
              );
              if (!e) {
                dispatch(setSelectPreUploadedFile([]));
              }
            }}
            modalTitle={
              resourceAddEditForm.formType == "create"
                ? "Create New Resource"
                : resourceAddEditForm.formType == "update"
                  ? "Edit Resource"
                  : ""
            }
            customModalHeader={"customNewResourceModalHeader"}
            resource-modal="resource-modal"
            size={"lg"}
            bodyComponent={
              <ResourcesModalSteps
                customModalBody={"customResourceModalBody"}
              />
            }
          />
        )}
      </div>
    </>
  );
};

export default ResourceHeader;
